import http from '@services/http'
import { IPreMatchResult, IPreMatchResultTrack } from '@protocol/result'
import { IMatchupTracks } from '@protocol/game'
import { GAME_TYPE } from '@game-type/game-market-types'

export default {
  getTournamentTracks(data: IMatchupTracks.Params): Promise<IPreMatchResultTrack.Schema> {
    if (data.gameType !== GAME_TYPE.LIVE && data.limit > 20) {
      data.limit = 20
    }
    return http.get('result/tournamentTracks', data || {})
  },
  getSpecial(data: IPreMatchResult.Params): Promise<IPreMatchResult.Schema> {
    return http.post('result/special', data || {})
  },
  getLive(data: IPreMatchResult.Params): Promise<IPreMatchResult.Schema> {
    return http.post('result/live', data || {})
  },
}
